import {
    BaseHttpService,
    ErrorMiddleware,
    GET, POST,
    MiddlewaresParams, RequestMiddleware, ResponseMiddleware, RequestOptions,
} from '../base-http-service'
import { Profile } from '../../domain/profile'
import { CompletedForm } from '../../domain/form'
import { components } from '../../domain/entities'

const REGISTRATION_BASE_URI = '/api/v1/profiles'
const VERIFICATIONS_BASE_URI = '/api/v1/verifications'
const UNSUBSCRIBING_BASE_URI = '/api/v1/unsubscribing'
const SECURITY_BASE_URI = '/api/v1/security'

const captchaTokenKey = 'X-Captcha-Token'

export class RegistrationService extends BaseHttpService {

    serviceRequestMiddlewares: RequestMiddleware[] = []
    serviceResponseMiddlewares: ResponseMiddleware[] = []
    serviceErrorMiddlewares: ErrorMiddleware[] = []

    constructor(serverUrl: string, middlewaresParams: MiddlewaresParams) {
        super()
        this.setServerUrl(serverUrl)

        this.serviceRequestMiddlewares = middlewaresParams.requestMiddlewares || []
        this.serviceResponseMiddlewares = middlewaresParams.responseMiddlewares || []
        this.serviceErrorMiddlewares = middlewaresParams.errorMiddlewares || []
    }

    getPersonalDataLink = ({ clientId }: { clientId: string }): Promise<string> => {
        return super.send<string>({
            method: GET,
            url: `${REGISTRATION_BASE_URI}/${clientId}/personal/link`
        })
    }

    getRegistrationChannelsForm = ({ clientId, channelId }: { clientId: string, channelId: string }): Promise<Profile> => {
        return super.send<Profile>({
            method: GET,
            url: `${REGISTRATION_BASE_URI}/${clientId}/${channelId}`,
            headers: {
                'Accept-Charset': 'charset=utf-8;',
            },
        })
    }

    fillForm = ({ clientId, channelId, form, captchaToken, }: {
        clientId: string,
        channelId: string,
        form: CompletedForm,
        captchaToken: string,
    }, options?: RequestOptions): Promise<components["schemas"]["Application"]> => {
        return super.send<components["schemas"]["Application"]>({
            method: POST,
            url: `${REGISTRATION_BASE_URI}/${clientId}/${channelId}/completed/forms`,
            data: form,
            headers: {
                [captchaTokenKey]: captchaToken
            }
        }, options)
    }

    sendVerificationCode = ({ clientId, applicationId, fieldId, code, captchaToken }: {
        clientId: string,
        applicationId: string,
        fieldId: string,
        code: string,
        captchaToken: string,
    }, options?: RequestOptions): Promise<void> => {
        return super.send<void>({
            method: POST,
            url: `${VERIFICATIONS_BASE_URI}/${clientId}/applications/${applicationId}/fields/${fieldId}`,
            params: {
                code
            },
            headers: {
                [captchaTokenKey]: captchaToken
            },
        }, options)
    }

    getCaptchaChallenge = (clientId, options?: RequestOptions): Promise<string> => {
        return super.send<string>({
            method: POST,
            url: `${SECURITY_BASE_URI}/${clientId}/captcha/images`
        }, options)
    }

    checkVerificationLink = (linkId: string, options?: RequestOptions): Promise<void> => {
        return super.send<void>({
            method: POST,
            url: `${VERIFICATIONS_BASE_URI}/links/${linkId}/confirm`,
        }, options)
    }

    unsubscribeClient = (clientId: string, encodedData: string, options?: RequestOptions): Promise<void> => {
        return super.send<void>({
            method: POST,
            url: `${UNSUBSCRIBING_BASE_URI}/${clientId}/customers`,
            params: {
                encodedData
            },
        }, options)
    }
}
